import { Icon, Tooltip } from 'copilot-design-system';
import { FunctionComponent, useState } from 'react';

import { LOGO_SIZE } from 'src/constants/logoConsts';

interface Props {
  /** className for the container */
  className?: string;
  /** className for the icon */
  iconClassName?: string;
  iconUrl: string;
  /** size in pixels */
  size?: number;
}

export const WorkspaceAvatar: FunctionComponent<Props> = ({
  className = '',
  iconClassName = '',
  iconUrl,
  size = LOGO_SIZE,
}) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const containerProps = {
    className: `flex items-center ${className}`,
    style: { width: size, height: size },
  };

  return hasError ? (
    <Tooltip content="Logo not found" position="bottom" offset={{ x: 50 }}>
      <div {...containerProps}>
        <Icon
          className={`text-light-gray w-full ${iconClassName}`}
          icon="ImageMissing"
        />
      </div>
    </Tooltip>
  ) : (
    <div {...containerProps}>
      <img
        alt="logo"
        className={
          `rounded text-transparent w-full h-full ${iconClassName} ` +
          (isLoaded ? 'bg-transparent' : 'bg-slate-100')
        }
        src={iconUrl}
        onError={() => {
          if (!hasError) {
            setHasError(true);
          }
        }}
        onLoad={() => {
          if (!isLoaded) {
            setIsLoaded(true);
          }
        }}
      />
    </div>
  );
};
